@if (showModal) {
    <div class="login-modal">
        <app-login (loginSuccessEvent)="loginCompleted()"></app-login>
    </div>
}
